import { CatalogStatus } from '../../../../utils/getCatalogStatus';

export enum CatalogCardTagType {
  INACTIVE = CatalogStatus.INACTIVE,
  NOT_IN_VALIDITY_DATE = CatalogStatus.NOT_IN_VALIDITY_DATE,
  LIVE_SHOP_VIDEO = 'LIVE_SHOP_VIDEO',
  LIVE_SHOP_ON_AIR = 'LIVE_SHOP_ON_AIR',
  DYNAMIC = 'DYNAMIC',
}

export interface CatalogCardTag {
  id: CatalogCardTagType;
  label: string;
  icon?: React.ReactElement;
}

export interface CatalogCardTagsProps {
  tags: CatalogCardTagType[];
}
